import VideoService from '@/services/videoservice'
// init state
const state = {
  categories: {},
  video: {},
  videos: [],
  dispVideos: [],
  sortBy: '',
  purchasedVideoIds: []
}
// getters
const getters = {
  getCategories: state => state.categories,
  getVideos: state => state.videos,
  getDispVideos: state => state.dispVideos,
  getSort: state => state.sortBy,
  getPurchasedVideoIds: state => state.purchasedVideoIds,
  hasPurchasedVideo: state => id => state.purchasedVideoIds.includes(id)
}
// actions
const actions = {
  async fetchVideoCategories (context) {
    await VideoService.getCategories()
      .then(response => {
        context.commit('setCategories', response.data)
      })
  },
  async fetchVideos (context) {
    await VideoService.getVideos()
      .then(response => {
        context.commit('setVideos', response.data)
      })
  },
  async fetchPurchasedVideoIds (context) {
    await VideoService.fetchPurchasedVideoIds()
      .then(response => {
        context.commit('setPurchasedVideoIds', response)
      })
      .catch(() => {})
  },
  async filterVideos ({ commit, state }, { searchQuery, category, onlyPremium, onlyPurchased }) {
    let filtered = state.videos.filter(video => {
      const matchTitleOrDesc = !searchQuery ||
        (video.title && video.title.includes(searchQuery)) ||
        (video.desc && video.desc.includes(searchQuery))

      const matchCategory = !category || video.category === Number(category)

      const matchPremium = !onlyPremium || (onlyPremium === 'true' && video.isTargetPremium)

      const matchPurchased = !onlyPurchased || (onlyPurchased === 'true' && video.isPurchased)

      return matchTitleOrDesc && matchCategory && matchPremium && matchPurchased
    })

    commit('setFilteredVideos', filtered)

    await this.dispatch('sortVideos')
  },
  async sortVideos ({ commit, state }) {
    const sorted = [...state.dispVideos].sort((a, b) => {
      // Prioritize videos with positionFlg true at the top
      if (a.positionFlg && !b.positionFlg) return -1
      if (!a.positionFlg && b.positionFlg) return 1

      // Then sort by the selected criteria
      switch (state.sortBy) {
        case 'comments':
          return b.comments - a.comments
        case 'likes':
          return b.likes - a.likes
        default:
          return b.id - a.id
      }
    })
    commit('setFilteredVideos', sorted)
  }
}
// mutations
const mutations = {
  setCategories (state, categories) {
    state.categories = categories
  },
  setVideos (state, videos) {
    state.videos = videos
    state.dispVideos = videos
  },
  setFilteredVideos (state, dispVideos) {
    state.dispVideos = dispVideos
  },
  setSortVideos (state, sortBy = '') {
    state.sortBy = sortBy
  },
  setPurchasedVideoIds (state, ids) {
    state.purchasedVideoIds = ids || []
  },
  clearStore (state) {
    state.categories = []
    state.video = {}
    state.videos = []
    state.dispVideos = []
    state.sortBy = ''
    state.purchasedVideoIds = []
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/video.js